import { render, staticRenderFns } from "./DoiSearch.vue?vue&type=template&id=fe544006&"
import script from "./DoiSearch.vue?vue&type=script&lang=js&"
export * from "./DoiSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports